/* Laitilio – carrito más rápido:
   1) En cuanto Shopify confirma el producto añadido, el carrito lateral se actualiza con el HTML que ya viene
      en esa respuesta (sin esperar la segunda petición del tema) y se abre.
   2) El botón de carrito de las tarjetas añade sin salir de la página. */
import { morphSection } from '@theme/section-renderer';
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.__ltCartFast) {
  window.__ltCartFast = true;

  const drawerSectionIds = () =>
    Array.from(document.querySelectorAll('cart-items-component'))
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);

  const openDrawer = () => {
    const comp = document.querySelector('cart-drawer-component[auto-open]');
    const drawer = document.querySelector('theme-drawer#cart-drawer');
    try { if (comp && drawer && !drawer.isOpen && typeof drawer.open === 'function') drawer.open(); } catch (e) {}
  };

  const applySections = (sections) => {
    if (!sections) return;
    for (const [id, html] of Object.entries(sections)) {
      if (!html || !document.getElementById('shopify-section-' + id)) continue;
      try { morphSection(id, html, { mode: 'hydration' }).catch(() => {}); } catch (e) {}
    }
  };

  // 1) Atajo sobre la petición de añadir al carrito del tema
  const nativeFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const req = nativeFetch(input, init);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      req.then((r) => r.clone().json()).then((data) => {
        if (!data || data.status || !data.sections) return;
        applySections(data.sections);
        openDrawer();
      }).catch(() => {});
    }
    return req;
  };

  // 2) Botón de carrito de las tarjetas (sección Bestsellers)
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('lt-bc__add')) return;
    e.preventDefault();
    const btn = form.querySelector('button');
    btn && btn.setAttribute('aria-busy', 'true');
    const fd = new FormData(form);
    const ids = drawerSectionIds();
    if (ids.length) fd.append('sections', ids.join(','));
    fd.append('sections_url', window.location.pathname);
    const deferred = CartLinesUpdateEvent.createPromise();
    form.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add', context: 'product',
      lines: [{ merchandiseId: String(fd.get('id')), quantity: Number(fd.get('quantity')) || 1 }],
      promise: deferred.promise,
    }));
    try {
      const res = await nativeFetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      });
      const data = await res.json();
      if (data.status) throw new Error(data.description || data.message);
      applySections(data.sections);
      openDrawer();
      const cart = await nativeFetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js').then((r) => r.json());
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'lt-card', sourceId: 'lt-card', itemCount: 1, sections: data.sections, didError: false },
      });
    } catch (err) {
      deferred.reject(err);
      form.submit();
    } finally {
      btn && btn.removeAttribute('aria-busy');
    }
  });
}
